export default function formatOneTimePasswordUrl ( email: string, provider: string, secret: string, issuer?: string ): string {
    return `otpauth://totp/${provider}:${email}?secret=${secret}&issuer=${issuer || provider}`
}
